import './ProductItemGridViewLayout.scss';

import ProductLink from '@components/ProductLink';
import classnames, { createClsNameMap } from '@utils/classnames';

import ProductItem from '../ProductItem';
import type { ProductItemProps } from '../types';

const clsNameMap = createClsNameMap({
  elements: {
    info: createClsNameMap(),
    image: createClsNameMap(),
    'cta-buttons': createClsNameMap(),
  },
})('product-item-grid-view-layout');

export type ProductItemGridViewLayoutProps = ProductItemProps & { hasCollection: boolean };

export const ProductItemGridViewLayout = (props: ProductItemGridViewLayoutProps) => {
  const { product, productInfo, productImg, popupSelectOption, hasCollection } = props;

  return (
    <ProductItem {...props} className={clsNameMap.root()}>
      <div className={clsNameMap.elm('image')}>
        <ProductLink
          data={product}
          className={classnames('product-link-image')}
          hasCollection={hasCollection}
        >
          <div style={{ position: 'relative' }}>
            {productImg}
            {popupSelectOption}
          </div>
        </ProductLink>
      </div>
      <ProductLink data={product} hasCollection={hasCollection}>
        {productInfo}
      </ProductLink>
    </ProductItem>
  );
};
